<template>
  <div class="border overflow-hidden rounded" v-if="items.length">
    <b-table :fields="fields" :items="items" borderless responsive foot-clone>
      <template #cell(index)="data">{{ data.index + 1 }}</template>
      <template #foot()="data">
        <span></span>
      </template>
      <template #foot(alternative_name)="data">
        <div class="body-font-button-sm text-neutral-950">Total</div>
      </template>
      <template #foot(total)="quantity">
        <div class="text-right body-font-button-sm text-neutral-950">{{ $numeral(total).format('0,0.[00]') }}</div>
      </template>
    </b-table>
  </div>
  <div v-else>-</div>
</template>

<script>
  export default {
    props: {
      items: {
        type: [Array],
        default: () => [],
      }
    },
    computed: {
      fields(){
        return [
          {key: 'index', label: 'No', sortable: false, thStyle: {width: '50px'}},
          {
            key: 'alternative_name',
            label: 'Nama',
            tdClass: 'text-start',
            formatter: (value) => this.lodash.upperFirst(value)
          },
          {
            key: 'total', label: this.lodash.startCase(this.$t('trip_items.total_price')),
            tdClass: 'text-end',
            thClass: 'text-end',
            formatter: (value) => this.$numeral(value).format('$ 0,0.[00]')
          },
        ]
      },
      total(){
        return this.items.reduce((prev, curr) => prev + curr.total, 0);
      }
    }
  }
</script>

<style scoped lang="scss">
@import "@/design/colors";
::v-deep {
  .overflow-hidden {
    overflow: hidden !important;
  }
  table {
    th {
      background: #F9FAFB !important;
    }

    thead {
      th * {
        color: $neutral-600;
      }
    }

    tbody {
      tr{
        border-bottom: 1px solid $slate-200 !important;
      }
    }

  }
  .table-responsive {
    margin-bottom: 0;
  }
  .text-right {
    text-align: right;
  }
}
</style>